import useSWR from "swr";
import axios from "axios";

function useXeroContacts({ shouldFetch = true }) {
  const url = `${process.env.REACT_APP_API_URL}/xero/contacts`;

  return useSWR(shouldFetch ? [url] : null, async ([url]) => {
    const params = new URLSearchParams();
    const { data: contacts } = await axios.get(`${url}?${params.toString()}`);

    return { contacts };
  });
}

export default useXeroContacts;
